/* batida-v7-kariera.js: /pages/kariera of the new batida.pl (Aleksandra's prototype _44, 27.09).
   Everything works without it (offers fold by themselves, the buttons jump to the list / the form, the job pills in the
   form are plain radio buttons); only the quiz needs it.
   - quiz "Co Cię nakręca?": answer -> "Pasujesz do nas jako <job>" + a button that opens that offer (-quiz, -jobs)
   - one offer open at a time also in browsers without <details name> (-jobs)
   - "Aplikuj na to stanowisko" / "Daj mi znać…" pick that job in the form and go there (-jobs, -form)
   - F26 (29.09) "+ Dołącz CV": asks Batida Connect (GET /apps/connect/kariera/cv) whether CV upload is on; only then
     the button uploads the file there (raw body, ?name=) and the staff link it returns goes into contact[CV]. While a
     CV uploads the send button waits. No answer / switched off / a failed upload = the e-mail link, as before.
   It never touches the form's submit (Shopify's own contact form + spam check post it normally). */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduce ? 'auto' : 'smooth';
  function norm(t) { return String(t || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
  function findJob(name) {
    var n = norm(name), hit = null;
    document.querySelectorAll('[data-v7k-job]').forEach(function (d) { if (!hit && norm(d.getAttribute('data-v7k-job')) === n) hit = d; });
    return hit;
  }
  function openJob(d) {
    document.querySelectorAll('.v7k-off').forEach(function (x) { if (x !== d) x.open = false; });
    d.open = true;
  }

  // one offer open at a time
  document.querySelectorAll('.v7k-off').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      document.querySelectorAll('.v7k-off').forEach(function (x) { if (x !== d && x.open) x.open = false; });
    });
  });

  // quiz
  document.querySelectorAll('[data-v7k-quiz]').forEach(function (root) {
    var box = root.querySelector('[data-v7k-match]');
    if (!box) return;
    var opts = [].slice.call(root.querySelectorAll('[data-job]'));
    opts.forEach(function (b) {
      b.addEventListener('click', function () {
        var name = b.getAttribute('data-job');
        var job = findJob(name);
        var open = job ? job.getAttribute('data-open') === '1' : false;   // 2.10: an offer not on the page (hidden) = not looking now -> the form
        opts.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        box.classList.remove('is-pop'); void box.offsetWidth; box.classList.add('is-pop');
        box.innerHTML = '<span>' + esc(root.getAttribute('data-fit') || '') + '<b>' + esc(name) + '</b></span>' +
          '<button type="button" class="v7k-btn v7k-btn--sm ' + (open ? 'v7k-btn--dark' : 'v7k-btn--line') + '" data-v7k-see>' +
            esc(root.getAttribute(open ? 'data-see' : 'data-closed') || '') + '</button>';
        var see = box.querySelector('[data-v7k-see]');
        if (see) see.addEventListener('click', function () {
          if (job) { openJob(job); job.scrollIntoView({ behavior: behavior, block: 'start' }); return; }
          var form = document.getElementById('aplikuj') || document.querySelector('[data-v7k-form], form');   // hidden offer: straight to the application form
          if (form) form.scrollIntoView({ behavior: behavior, block: 'start' });
        });
      });
    });
  });

  // F26: CV upload to Batida Connect (private storage), mailto until it answers
  document.querySelectorAll('[data-v7k-cv]').forEach(function (box) {
    var api = box.getAttribute('data-api'), file = box.querySelector('[data-v7k-cv-file]'), url = box.querySelector('[data-v7k-cv-url]');
    var btn = box.querySelector('[data-v7k-cv-btn]'), mail = box.querySelector('[data-v7k-cv-mail]'), msg = box.querySelector('[data-v7k-cv-msg]');
    var rodo = box.querySelector('[data-v7k-cv-rodo]'), label = box.querySelector('[data-v7k-cv-label]'), label0 = label ? label.textContent : '';
    if (!api || !file || !url || !btn || !window.fetch) return;
    var form = box.closest('form'), send = form && form.querySelector('[type="submit"]'), sendText = send ? send.textContent : '';
    var T = {}; ['busy', 'done', 'err', 'type', 'big', 'macros', 'limit', 'wait', 'mail'].forEach(function (k) { T[k] = box.getAttribute('data-t-' + k) || ''; });
    var rules = null;
    function note(text, bad) { if (!msg) return; msg.hidden = !text; msg.textContent = text || ''; msg.classList.toggle('is-bad', !!bad); }
    function fallback() { if (!mail) return; if (T.mail) mail.textContent = T.mail; mail.hidden = false; }
    function busy(on) {
      box.classList.toggle('is-busy', on);
      if (send) { send.disabled = on; send.textContent = on ? (T.wait || sendText) : sendText; }
      if (label) label.textContent = on ? (T.busy || label0) : label0;
    }
    function kb(n) { return n >= 1048576 ? (n / 1048576).toFixed(1).replace('.', ',') + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB'; }
    function day(iso) { var p = String(iso || '').split('-'); return p.length === 3 ? p[2] + '.' + p[1] + '.' + p[0] : iso; }
    fetch(api, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.ok || !j.enabled) return;
        rules = j;
        file.disabled = false; btn.hidden = false; if (mail) mail.hidden = true;
        if (rodo) { rodo.hidden = false; var d = rodo.querySelector('[data-v7k-cv-days]'); if (d && j.retentionDays) d.textContent = j.retentionDays; }
      })
      .catch(function () { /* keep the e-mail link */ });
    file.addEventListener('change', function () {
      var f = file.files && file.files[0];
      if (!f || !rules) return;
      var ext = (f.name.match(/\.([a-z0-9]+)$/i) || [])[1];
      if (!ext || (rules.types || []).indexOf(ext.toLowerCase()) < 0) { note(T.type, true); file.value = ''; return; }
      if (f.size > (rules.maxBytes || 10485760)) { note(T.big, true); file.value = ''; return; }
      note(''); busy(true); url.value = ''; box.classList.remove('is-done');
      var type = f.type || ({ pdf: 'application/pdf', doc: 'application/msword', docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', odt: 'application/vnd.oasis.opendocument.text' })[ext.toLowerCase()] || 'application/octet-stream';
      fetch(api + (api.indexOf('?') < 0 ? '?' : '&') + 'name=' + encodeURIComponent(f.name), { method: 'POST', headers: { 'Content-Type': type, Accept: 'application/json' }, body: f, credentials: 'same-origin' })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, j: j || {} }; }); })
        .then(function (res) {
          var j = res.j;
          if (res.status === 201 && j.ok && j.url) {
            url.value = j.url + ' (plik: ' + f.name + ', ' + kb(j.size || f.size) + ', link ważny do ' + day(j.expires) + ')';
            box.classList.add('is-done');
            note((T.done || '{plik}').replace('{plik}', f.name));
            return;
          }
          if (res.status === 413 || j.error === 'too_large') note(T.big, true);
          else if (j.error === 'macros') note(T.macros, true);
          else if (res.status === 415 || res.status === 400) note(T.type, true);
          else if (res.status === 429) { note(T.limit, true); fallback(); }
          else { note(T.err, true); fallback(); }
        })
        .catch(function () { note(T.err, true); fallback(); })
        .then(function () { busy(false); file.value = ''; });
    });
  });

  // offer buttons -> pick the job in the form
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-v7k-role]');
    if (!a) return;
    var id = (a.getAttribute('href') || '').replace(/^#/, '');
    var form = id && document.getElementById(id);
    if (!form) return;
    e.preventDefault();
    var want = norm(a.getAttribute('data-v7k-role'));
    var radios = [].slice.call(form.querySelectorAll('input[type="radio"][name="contact[Stanowisko]"]'));
    var hit = radios.filter(function (r) { var l = r.parentNode && r.parentNode.querySelector('span'); return norm(r.value) === want || (l && norm(l.textContent) === want); })[0];
    if (hit) hit.checked = true;
    form.scrollIntoView({ behavior: behavior, block: 'start' });
    var first = form.querySelector('input[name="contact[name]"]');
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (err) {} }, reduce ? 0 : 600);
  });
})();
